import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const VIEW_AS_KEY = "livehub_view_as_contractor";

export const getViewAs = () => {
  try { return JSON.parse(localStorage.getItem(VIEW_AS_KEY) || "null"); } catch { return null; }
};

export const startViewAs = (contractor) => {
  localStorage.setItem(VIEW_AS_KEY, JSON.stringify({ id: contractor.id, name: contractor.name }));
  window.location.assign("/dashboard");
};

export const stopViewAs = () => {
  localStorage.removeItem(VIEW_AS_KEY);
  window.location.assign("/contractors");
};

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const v = getViewAs();
  if (v?.id && !(config.url || "").startsWith("/auth/logout")) {
    config.headers["X-View-As-Contractor"] = v.id;
  }
  return config;
});

api.interceptors.response.use(undefined, (err) => {
  if (getViewAs() && err?.response?.status === 400 && /visualiza/.test(err.response.data?.detail || "")) {
    localStorage.removeItem(VIEW_AS_KEY);
    window.location.reload();
  }
  return Promise.reject(err);
});

export default api;
